export default ({ request }) => ({
  // 发运报关收发货人信息表
  shipmentCustomerListApi(data = {}) {
    return request({
      url: '/factory/shipment/customer/list',
      method: 'post',
      data
    })
  },
  shipmentCustomerDetailApi(data = {}) {
    return request({
      url: '/factory/shipment/customer/detail',
      method: 'post',
      data
    })
  },
  shipmentCustomerSaveApi(data = {}) {
    return request({
      url: '/factory/shipment/customer/save',
      method: 'post',
      data
    })
  },
  shipmentCustomerDelApi(data = {}) {
    return request({
      url: '/factory/shipment/customer/del',
      method: 'post',
      data
    })
  },
  // 收发货人相关地址表
  shipmentCustomerAddressListApi(data = {}) {
    return request({
      url: '/factory/shipment/customer/address/list',
      method: 'post',
      data,
    })
  },
  shipmentCustomerAddressDetailApi(data = {}) {
    return request({
      url: '/factory/shipment/customer/address/detail',
      method: 'post',
      data,
    })
  },
  shipmentCustomerAddressSaveApi(data = {}) {
    return request({
      url: '/factory/shipment/customer/address/save',
      method: 'post',
      data,
    })
  },
  shipmentCustomerAddressDelApi(data = {}) {
    return request({
      url: '/factory/shipment/customer/address/del',
      method: 'post',
      data,
    })
  },
  // 收发货人文件表
  shipmentCustomerFileListApi(data = {}) {
    return request({
      url: '/factory/shipment/customer/file/list',
      method: 'post',
      data
    })
  },
  shipmentCustomerFileUploadApi(data = {}) {
    return request({
      url: '/factory/shipment/customer/file/upload',
      method: 'post',
      data
    })
  },
  shipmentCustomerFileDelApi(data = {}) {
    return request({
      url: '/factory/shipment/customer/file/del',
      method: 'post',
      data
    })
  },
  shipmentCustomerFileDetailApi(data = {}) {
    return request({
      url: '/factory/shipment/customer/file/detail',
      method: 'post',
      data
    })
  },
  shipmentCustomerFileUpdateApi(data = {}) {
    return request({
      url: '/factory/shipment/customer/file/update',
      method: 'post',
      data
    })
  },
})
